import React, { useContext } from "react";
import styled from "styled-components";
import Context from "../../../../../Context";
// import { useScroll } from "@react-three/drei";
import { useTransform, useScroll, motion } from "framer-motion";
import supportedGpuTypes from "../../../../../data/supportedGpuTypes";

const PageWrapper = styled.div`
  /* background: linear-gradient(180deg, #f6f6ff 0%, #eae8ff 100%); */
  color: #2a2752;
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  padding: 60px 40px;
  gap: 100px;
  margin-top: 100px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
`;

const Header = styled.h1`
  font-size: 2.8rem;
  font-weight: 600;
  margin-bottom: 0;
  color: #2a2752;
`;

const SubText = styled.p`
  color: #5b567f;
  font-size: 1rem;
  /* text-align: center; */
  max-width: 550px;
  line-height: 1.6;
`;

const TableWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  /* border-top: 1px solid rgba(177, 166, 255, 0.3); */
`;

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  margin-top: 30px;
`;

const SectionLabel = styled.span`
  font-size: 1rem;
  color: #7b74a6;
  letter-spacing: 0.5px;
`;

const GPUCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  backdrop-filter: blur(16px);
  background: rgba(255, 255, 255, 0.45);
  border: 1px solid rgba(177, 166, 255, 0.3);
  padding: 20px 25px;
  border-radius: 16px;
  margin-bottom: 14px;
  box-shadow: 0 6px 20px rgba(177, 166, 255, 0.15);
  transition: all 0.25s ease;
  /* &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(177, 166, 255, 0.25);
    background: rgba(255, 255, 255, 0.6);
  } */

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 15px;
    padding: 25px;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const GPUName = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  flex: 1;
  color: #2a2752;
`;

const GPUInfo = styled.div`
  display: flex;
  gap: 10px;
  flex: 3;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    /* justify-content: center; */
    /* align-items: center; */
  }
`;

const Tag = styled.span`
  background-color: rgba(177, 166, 255, 0.12);
  border: 1px solid rgba(177, 166, 255, 0.3);
  color: #3b347a;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 0.9rem;
`;

const Price = styled.div`
  font-size: 1rem;
  color: #6b5fff;
  font-weight: 600;
  flex: 1;
  text-align: right;
`;

const ArrowButton = styled.button`
  background: rgba(177, 166, 255, 0.2);
  border: 1px solid rgba(177, 166, 255, 0.4);
  color: #6b5fff;
  padding: 8px 10px;
  border-radius: 50%;
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: rgba(177, 166, 255, 0.35);
    transform: scale(1.1);
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const GpuSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const GPUSection = ({ title, gpus }) => (
  <GpuSectionContainer>
    <SectionTitle>
      <SectionLabel>{title}</SectionLabel>
    </SectionTitle>
    {gpus.map((gpu, idx) => (
      <GPUCard key={idx}>
        <GPUName>{gpu.secondaryLabel}</GPUName>
        <GPUInfo>
          {gpu.features.map((item) => (
            <Tag>{item}</Tag>
          ))}
        </GPUInfo>
        <Price>${gpu.price / 100} / Hr</Price>
        {/* <ArrowButton>→</ArrowButton> */}
      </GPUCard>
    ))}
  </GpuSectionContainer>
);

const Layer = styled(motion.div)``;

export default function PricingSection() {
  const { mainScrollRef } = useContext(Context);
  const { scrollY } = useScroll({ container: mainScrollRef });

  const y1 = useTransform(scrollY, [1000, 2000], [0, 1]);
  const y2 = useTransform(scrollY, [1000, 2000], [-800, 0]);

  const gpuGroups = [
    {
      title: "Ampere Architecture - Fast",
      gpus: [
        supportedGpuTypes.A40,
        supportedGpuTypes.L40S,
        supportedGpuTypes.A100_80GB_PCIE,
      ],
    },
    // {
    //   title: "Hopper Architecture - Blazing Fast",
    //   gpus: [supportedGpuTypes.H100_PCIE],
    // },
  ];

  return (
    <PageWrapper id="pricing-section">
      <Layer style={{ x: y2 }}>
        <HeaderSection>
          <Header>GPU Cloud Pricing</Header>
          <SubText>
            Simple, transparent pricing plans for teams of all sizes.
          </SubText>
        </HeaderSection>
      </Layer>

      <TableWrapper>
        <Layer style={{ scale: y1, width: "100%" }}>
          {gpuGroups.map((section, i) => (
            <GPUSection key={i} title={section.title} gpus={section.gpus} />
          ))}
        </Layer>
      </TableWrapper>
    </PageWrapper>
  );
}
